


import React, { useContext, useState } from "react";
import FlechaIzquierdaIcon from "../../../assets/images/generico/FlechaIzquierdaIcon";
import { PortalContext } from "../../../context/Provider";
import "./PreguntasFrecuentesPcr.css"

const PreguntasFrecuentesPcr = ({ pregunta }) => {
  const { preguntasFrecuentesState } = useContext(PortalContext);
  const [selected, setSelected] = useState(0);

  const handleClickMenu = () => {
    if (!selected || selected !== pregunta) {
      setSelected(pregunta);
    } else {
      setSelected(false);
    }
  };

  const itemSelected = selected === pregunta;

  return (
    <div className="ptur-preguntasFrecuentesPcr-card">
      <div>
        <ul className="ptur-list-preguntasFrecuentesPcr">
          <li
            className="ptur-option-preguntasFrecuentesPcr rb14b"
            id={itemSelected ? "active" : ""}
            onClick={() => handleClickMenu()}
          >
            <div className="ptur-preguntasFrecuentesPcr-tituloFlecha">
              {pregunta}
              {itemSelected ? (
                <div className="ptur-preguntasFrecuentesPcr-flechaCerrar">
                  <FlechaIzquierdaIcon />
                </div>
              ) : (
                <div className="ptur-preguntasFrecuentesPcr-flechaAbrir">
                  <FlechaIzquierdaIcon />
                </div>
              )}
            </div>
            {Array.isArray(preguntasFrecuentesState.preguntasFrecuentes.data) &&
              preguntasFrecuentesState.preguntasFrecuentes.data.map(
                (val, index) => {
                  const itemSelected = selected === val.pregunta;
                  return (
                    <React.Fragment key={index}>
                      <div className="ptur-preguntasFrecuentesPcr-textoCard">
                        {itemSelected ? (
                          <div
                            className="content rb14l"
                            dangerouslySetInnerHTML={{ __html: val.respuesta }}
                          ></div>
                        ) : (
                          ""
                        )}
                      </div>
                    </React.Fragment>
                  );
                }
              )}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PreguntasFrecuentesPcr;
